export interface TouchTravelled {
  x: number;
  y: number;
  direction?: TouchDirection;
}

export enum TouchDirection {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  NO_ACTION = 'NO_ACTION'
}
